export default {
  isLiteral: true,
  inserted: function (el, binding, vnode) {
    window.addEventListener('click', function (e) {
      if (!el.contains(e.target)) {
        binding.value && binding.value()
      }
    })
  }
}
